"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCompareSelectorAlpha = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const ProductSelector_1 = require("../../../redux/product/selectors/ProductSelector");
const CompareActions_creators_1 = tslib_1.__importDefault(require("../../../redux/compare/actions/CompareActions.creators"));
const ProductConstants_1 = require("../../../constants/ProductConstants");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const CompareSelectors_1 = require("../../../redux/compare/selectors/CompareSelectors");
const common_components_1 = require("@as-react/common-components");
const andes_react_1 = require("@yonderland/andes-react");
const andes_icons_1 = require("@yonderland/andes-icons");
const ProductCompareSelectorAlpha = () => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.product);
    const { brand, seoUrl, colorId, productId, productCode, title, image, colorDescription, sizes, gender, buyingGroup, productQualifier, brandValue, } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductCompareInformation)());
    const isCompareProduct = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetIsCompareProduct)());
    const selectedSku = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetSelectedSku)());
    const compareItems = (0, react_redux_1.useSelector)((0, CompareSelectors_1.makeGetCompareItems)());
    const { isXs, isSm } = (0, andes_react_1.useBreakpoints)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { rootWithLanguageSuffix, root } = (0, common_components_1.useAemConfig)();
    const isMobile = isXs || isSm;
    const selectedSize = sizes === null || sizes === void 0 ? void 0 : sizes.find((size) => size.sku === selectedSku);
    const compareProduct = {
        id: productId,
        color: colorId,
        url: `${rootWithLanguageSuffix}/${ProductConstants_1.PRODUCT_URL_PREFIX}${seoUrl.indexOf('/') === 0 ? '' : '/'}${seoUrl}.html?colour${colorId}`,
        title,
        brand,
        image,
        productCode,
        selected: false,
        colorDescription,
        size: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.originalSize) !== '.' ? selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.originalSize : undefined,
        collapsedComparePopup: true,
        gender,
        buyingGroup,
        productQualifier,
        brandValue,
    };
    const showLinkToComparePage = isMobile && isCompareProduct && (compareItems === null || compareItems === void 0 ? void 0 : compareItems.length) > 1;
    const handleChange = () => {
        dispatch(CompareActions_creators_1.default.createUpdateOnProductDetailPageAction(compareProduct));
    };
    return ((0, jsx_runtime_1.jsxs)(andes_react_1.StackInline, { gap: "2", itemsAlign: "center", children: [(0, jsx_runtime_1.jsx)(andes_react_1.Checkbox, { dataTestId: "product_compare_checkbox", id: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, name: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, value: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, checked: isCompareProduct, onChange: handleChange, label: showLinkToComparePage ? undefined : t('product:productCompare.pdp.checkbox') }), showLinkToComparePage && ((0, jsx_runtime_1.jsx)(andes_react_1.Link, { dataTestId: "product_compare_link", variant: "primary", theme: "neutral", iconRight: { source: andes_icons_1.CaretRightIcon, size: 'xs' }, href: `${root}products/product-compare.html`, children: t('productCompare.pdp.checkbox') }))] }));
};
exports.ProductCompareSelectorAlpha = ProductCompareSelectorAlpha;
